module.exports = __webpack_public_path__ + "static/media/Sea-Lifts-Logo.4643cf2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Footer/images/Sea-Lifts-Logo.png
// module id = 1236
// module chunks = 0